import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './components/main/main.component';
import { RoleGuardService as RoleGuard } from './services/role-guard.service';
import { QuicklinkModule, QuicklinkStrategy } from 'ngx-quicklink';
const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('./components/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: 'prestador/:codigo',
    loadChildren: () =>
      import('./components/prestacion-rapida/prestacionRapida.module').then(
        (m) => m.PrestacionRapidaModule
      ),
  },
  {
    path: 'redirect',
    loadChildren: () =>
      import('./components/redirect/redirect.module').then(
        (m) => m.RedirectModule
      ),
  },
  {
    path: 'main',
    component: MainComponent,
    canActivate: [RoleGuard],
  },
  {
    path: '',
    component: MainComponent,
    children: [
      {
        path: 'inicio',
        loadChildren: () =>
          import('./components/inicio/inicio.module').then(
            (m) => m.InicioModule
          ),
      },
      {
        path: 'prestacion',
        loadChildren: () =>
          import('./components/prestacion/prestacion.module').then(
            (m) => m.PrestacionModule
          ),
      },
      {
        path: 'cambiar-password',
        loadChildren: () =>
          import('./components/cambiar-password/cambiar-password.module').then(
            (m) => m.CambiarPasswordModule
          ),
      },
      {
        path: 'usuarios',
        canActivate: [RoleGuard],
        data: {
          expectedRole: 'usuarios'
        },
        loadChildren: () =>
          import('./components/usuarios/usuarios.module').then(
            (m) => m.UsuariosModule
          ),
      },
      { path: '', redirectTo: '/login', pathMatch: 'full' },
    ],
  },
  {
    path: 'olvide-password',
    loadChildren: () =>
      import('./components/olvide-password/olvide-password.module').then(
        (m) => m.OlvidePasswordModule
      ),
  },

  //{ path: '', redirectTo: 'redirect',  pathMatch: 'full' },
  { path: '**', redirectTo: '/login', pathMatch: 'full' },
];

export const APP_ROUTING = RouterModule.forRoot(routes, {
  preloadingStrategy: QuicklinkStrategy,
});
@NgModule({
  imports: [RouterModule.forRoot(routes), QuicklinkModule],
  exports: [RouterModule],
})
export class AppRoutingModule {}
